<template>
    <div>
    <Nav :isDark.sync="this.isDark" @darkmode="isDark = $event"></Nav>
    <div v-loading="loading">
    <div class="container py-2" :style="{height: this.tableData.length === 0 || loading ? 'calc(100vh - 129px)' : 'auto'}">
        <h1 class="fs-24 text-center mt-2">{{this.type}}数据获取</h1>
        <div class="mt-4 mb-4">
            <div class="d-flex justify-content-between">
                <b>选择联赛：</b>
                <div>
                    <el-radio v-model="radio" label="fb" @input="changeType">足球</el-radio>
                    <el-radio v-model="radio" label="bb" @input="changeType">篮球</el-radio>
                </div>
            </div>
            <div v-if="leagueList.length > 0 && radio == 'bb'" class="my-2">
                <div>
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <el-checkbox-group v-model="checkedLeague" @change="handleCheckedChange">
                        <el-checkbox v-for="(item,index) in leagueList" :label="item" :key="index" class="mt-2">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div class="mt-4 text-center">
                    <el-button type="primary" v-loading.fullscreen.lock="fullscreenLoading" @click="updateLgData">更新联赛数据</el-button>
                    <el-button type="success" v-loading.fullscreen.lock="fullscreenLoading" @click="getMatch(true)">抓取今日数据</el-button>
                    <el-button type="success" v-loading.fullscreen.lock="fullscreenLoading" @click="getMatch(false)">抓取明日数据</el-button>
                    <el-button type="warning" v-loading.fullscreen.lock="fullscreenLoading" @click="getMatch(true)">提前1天抓取明日数据</el-button>
                </div>
            </div>
            <div v-if="fbLeagueList.length > 0 && radio == 'fb'" class="my-2">
                <div>
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <el-checkbox-group v-model="checkedLeague" @change="handleCheckedChange">
                        <el-checkbox v-for="(item,index) in fbLeagueList" :label="item" :key="index" class="mt-2">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div class="mt-4 text-center">
                    <el-button v-if="radio == 'fb'" type="info" v-loading.fullscreen.lock="fullscreenLoading" @click="crawlerCheckLeague">获取联赛列表</el-button>
                    <el-button type="primary" v-loading.fullscreen.lock="fullscreenLoading" @click="updateFbLgData">更新联赛数据</el-button>
                    <el-button type="success" v-loading.fullscreen.lock="fullscreenLoading" @click="getMatch(false)">抓取今日数据</el-button>
                    <el-button type="warning" v-loading.fullscreen.lock="fullscreenLoading" @click="getMatch(true)">抓取明日数据</el-button>
                </div>
            </div>
        </div>
        <div class="mt-4">
            <b>抓取的比赛：</b>
        </div>
        <div :class="{'d-none': loading}">
            <!-- <el-button class="mb-3" type="primary" v-loading.fullscreen.lock="fullscreenLoading" @click="getMatch()">重新抓取</el-button> -->
            <div class="d-flex justify-content-between">
                <b>{{ this.dateTitle }}</b>
                <div>
                    <el-button type="text" @click="reCrawler()" class="fs-12 text-end text-primary">不满意？重新抓取比赛>></el-button>
                </div>
            </div>
            <Edite class="mt-2" :matchdata="this.tableData" :emptyText="this.emptyText" :reload = "this.reloadTable"></Edite>
            <div class="mt-2 text-end">
                <el-button type="primary" v-loading.fullscreen.lock="fullscreenLoading" @click="upLoadDate">上传数据</el-button>
            </div>
        </div>
    
    </div>
    </div>
    <Footer></Footer>
    </div>
</template>
<script>
import Edite from '../edite/edite-bsk-match.vue';
import Nav from '../comment/nav.vue'
import Footer from '../comment/footer.vue'
import {changeLeagueName,changeTeamName} from '@/utils/change';
import {setcolor } from '@/utils/setcolor';
import { uploadMatches } from '../../constants/http.config';
export default {
    components: { Edite, Nav,Footer },
    inject: ['reload'],
    data() {
        return {
            loading: true,
            fullscreenLoading: false,
            tips: '',
            tableData: [],
            dateTitle: '',
            isDark: false,
            reloadTable: false,
            emptyText: '数据加载中...',
            filters: [],
            isphone: false,
            isIndeterminate: false,
            checkAll: false,
            checkedCount: 0,
            columns: [
                { label: '联赛', prop: 'league' },
                { label: '时间', prop: 'time' },
                { label: '主排名', prop: 'homeRank' },
                { label: '主队', prop: 'home' },
                { label: 'qsda', prop: 'qsda' },
                { label: '客队', prop: 'away' },
                { label: '客排名', prop: 'awayRank' },
                { label: '指数1', prop: 'index1' },
                { label: 'Crow', prop: 'handicap' },
                { label: '指数2', prop: 'index2' },
                { label: '小球', prop: 'small' },
                { label: '大小', prop: 'bigsmall' },
                { label: '大球', prop: 'big' },
                { label: 'id', prop: 'id' },
            ],
            leagueList: [],
            fbLeagueList: [],
            checkedLeague: [],
            checkedLeagueList: [],
            radio: 'fb',
            type: '足球'
        }
    },
    mounted() {
        this.getFbLeagueList();
        this.getBbLeagueList();
        this.getCheckLeague();
        this.validatorData();
        // this.getzs();
        // const currentYear = new Date().getFullYear();
        // console.log('yyyyy',currentYear);
    },
    methods: {
        dateFormatted (date) {
            // const date = new Date();
            const year = date.getFullYear();
            let month = date.getMonth();
            let day = date.getDate();
            month = month < 9 ? '0'+( month + 1) : month + 1;
            day = day < 10 ? '0' + day : day;
            return year + '-' + month+'-' + day;
        },
        getBbLeagueList(){
            const url = '/basketball/league/list';
            fetch(url)
            .then(response => response.json())
            .then(data => {
                console.log(data.data);
                this.leagueList = data.data;
            }).catch(err=>{
                console.log(err);
            })
        },
        getFbLeagueList(){
            const url = '/football/league/list';
            fetch(url)
            .then(response => response.json())
            .then(data => {
                // console.log('0000000',data.data);
                for (let index = 0; index < data.data.length; index++) {
                    const elm = data.data[index];
                    if (!elm.isHide) {
                        this.fbLeagueList.push(elm)
                    }
                }
                // this.fbLeagueList = data.data;
                
                // this.checkedLeague = ["墨西联",'德甲','意甲']
            }).catch(err=>{
                console.log(err);
            })
        },
        validatorData(){
            console.log('验证数据');
            let date = new Date();
            date.setDate(date.getDate() + 1);
            const today = this.dateFormatted(new Date());
            const tomorrowDate = this.dateFormatted(date);
            console.log(tomorrowDate);
            // const url = 'https://api.qsda.net/api/match/today';
            let url = ''
            if (this.type === '足球') {
                url = '/football/match/' + today;
            }
            if (this.type === '篮球') {
                url = '/basketball/match/' + today;
            }
            fetch(url)
            .then(response => response.json())
            .then(data => {
                if (data.code === 200) {
                    this.tableData = data.data;
                    this.dateTitle = data.data.length > 0 ? data.data[0].date : '';
                    if (this.tableData.length == 0) {
                        this.emptyText = '暂无数据';
                    }else{
                        this.emptyText = '加载中...';
                    }
                    this.loading = false;
                    this.reloadTable = true;
                    console.log(this.tableData);
                }else{
                    this.loading = false;
                    this.emptyText = '暂无数据';
                }
            }).catch(err=>{
                this.loading = false;
                this.emptyText = '暂无数据';
                this.reloadTable = true;
                console.log('读取数据出错',err);
            })
        },
        getMatch(isTomorrow){
            this.fullscreenLoading = true;
            let url = '';
            if (!isTomorrow && this.type === '足球') {
                url = '/crawler/football/today-match';
            }
            if (isTomorrow && this.type === '足球') {
                url = '/crawler/football/tomorrow-match';
            }
            if (!isTomorrow && this.type === '篮球') {
                url = '/crawler/basketball/tomorrow-match';
            }
            if (isTomorrow && this.type === '篮球') {
                url = '/crawler/basketball/today-match';
            }
            console.log(url);
            
            // const url = 'http://localhost:8888/api/crawler/today';
            fetch(url,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(data => {
                this.fullscreenLoading = false;
                if (data.code == 200) {
                    this.$notify({
                        title: '抓取成功',
                        message: data.data,
                        type: 'success',    
                        // duration: 0
                    });
                    this.validatorData();
                } else {
                    this.tips = '抓取失败，请检查格式是否正确！';
                    this.$notify.error({
                        title: '抓取失败',
                        message: '未知错误，请重试',
                        // duration: 0
                    });
                }
                console.log(data);
            }).catch(err=>{
                this.fullscreenLoading = false;
                this.$notify.error({
                        title: '抓取失败',
                        message: '连接超时',
                        // duration: 0
                    });
                console.error(err);
            })
        },
        reCrawler(){
            this.tableData = [];
            this.reloadTable =true;
            this.emptyText = '暂无数据';
        },
        tableRowClassName({ rowIndex }) {
            // console.log(rowIndex);
            // 根据行的索引自定义类名
            return this.ishide[rowIndex] ? 'd-none' : '';
        },
        qsdaColorSet(handicap,qsda){
            let qsdaColor = 'rgb(128,0,255)';
            return qsdaColor;
        },
        filterTag({value, row, column}) {
            const property = column['property'];
            // console.log(row[property],row[property] === value);
            if (value === '竞足') {
                // 当选择 '竞足' 时，检查 myLeague1 数组中的任何一个值是否与 row[property] 匹配
                const match = this.myLeague1.some(league => row[property] === league);
                return match;
            }else if(value === '北单'){
                // 当选择 '北单' 时，检查 myLeague2 数组中的任何一个值是否与 row[property] 匹配
                const match = this.myLeague2.some(league => row[property] === league);
                return match;
            }else{
                // 重置 ishide 数组
                this.ishide.forEach((_, index) => {
                    this.ishide[index] = false;
                });
                return row[property] === value;
            }
        },
        handleCheckAllChange(val) {
            if (this.type === '足球') {
                this.checkedLeagueList = val ? this.fbLeagueList.map(item => item) : [];
                this.checkedLeague = val ? this.fbLeagueList.map(item => item) : [];
            }
            if (this.type === '篮球') {
                this.checkedLeague = val ? this.leagueList.map(item => item) : [];
            }
            this.isIndeterminate = false;
            console.log('9999',val,this.checkedLeague);
        },
        handleCheckedChange(value) {
            console.log(value);
            this.checkedCount = value.length;
            this.checkAll = this.checkedCount === this.leagueList.length;
            this.isIndeterminate = this.checkedCount > 0 && this.checkedCount < this.leagueList.length;
        },
        updateLgData(){
            // this.fullscreenLoading = true;
            if (this.checkedCount == 0) {
                this.$message.error('请至少选中一个联赛!');
            }else {
                console.log('更新..',this.checkedLeague);
                this.loading = true;
                const url = '/crawler/basketball/lg-rank';
                fetch(url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(this.checkedLeague)
                })
                .then(response => response.json())
                .then(data => {
                    if (data.code == 200) {
                        this.$notify({
                            title: '抓取成功',
                            message: data.data,
                            type: 'success',    
                            // duration: 0
                        });
                    } else {
                        this.$notify.error({
                            title: '抓取失败',
                            message: '请检查代码',
                            // duration: 0
                        });
                    }
                    console.log(data);
                    this.fullscreenLoading = false;
                    this.loading = false;
                }).catch(err=>{
                    this.fullscreenLoading = false;
                    this.loading = false;
                    this.$notify.error({
                            title: '抓取失败',
                            message: '未知错误，请重试',
                        });
                    console.error(err);
                })
            }
        },
        updateFbLgData(){
            console.log('sssss',this.checkedLeague);
            // for (let index = 0; index < this.checkedLeagueList.length; index++) {
            //     for (let i = 0; i < this.fbLeagueList.length; i++) {
                    
            //     }
            // }
            if (this.checkedLeague.length == 0) {
                this.$message.error('请至少选中一个联赛!');
            }else {
                console.log('更新..',this.checkedLeague);
                this.loading = true;
                const url = '/crawler/football/lg-rank';
                fetch(url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(this.checkedLeague)
                })
                .then(response => response.json())
                .then(data => {
                    if (data.code == 200) {
                        this.$notify({
                            title: '抓取成功',
                            message: data.data,
                            type: 'success',    
                            // duration: 0
                        });
                    } else {
                        this.$notify.error({
                            title: '抓取失败',
                            message: '请检查代码',
                            // duration: 0
                        });
                    }
                    console.log(data);
                    this.fullscreenLoading = false;
                    this.loading = false;
                }).catch(err=>{
                    this.fullscreenLoading = false;
                    this.loading = false;
                    this.$notify.error({
                            title: '抓取失败',
                            message: '未知错误，请重试',
                        });
                    console.error(err);
                })
            }
        },
        changeType(){
            if (this.radio === 'fb') {
                this.type = '足球';
                this.checkAll = false;
                this.checkedLeague = [];
                this.checkedCount = 0;
                this.tableData = [];
                this.validatorData();
            }else{
                this.type = '篮球';
                this.checkAll = false;
                this.checkedLeague = [];
                this.checkedCount = 0;
                this.tableData = [];
                this.validatorData();
            }
        },
        //获取要抓取的联赛列表
        async getCheckLeague(){
            const url = '/football/league/checkLg';
            fetch(url)
            .then(response => response.json())
            .then(data => {
                // console.log('yyyyy',data.data[0].data);
                    for (let index = 0; index < data.data[0].data.length; index++) {
                        for (let i = 0; i < this.fbLeagueList.length; i++) {
                            const lgname = this.fbLeagueList[i].name;
                            if (data.data[0].data[index] === lgname) {
                                // this.checkedLeagueList.push(data.data[0].data[index]);
                                this.checkedLeague.push(this.fbLeagueList[i]);
                            }
                        }
                    }
                // console.log('121212',this.checkedLeagueList.length,this.checkedLeague.length);
            }).catch(err=>{
                console.log(err);
            })
        },
        crawlerCheckLeague(){
            this.loading = true;
            const url = '/crawler/football/checkLg';
            fetch(url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(this.checkedLeague)
                })
                .then(response => response.json())
                .then(data => {
                    if (data.code == 200) {
                        this.$notify({
                            title: '抓取成功',
                            message: data.data,
                            type: 'success',    
                            // duration: 0
                        });
                    } else {
                        this.$notify.error({
                            title: '抓取失败',
                            message: '请检查代码',
                            // duration: 0
                        });
                    }
                    console.log(data);
                    this.fullscreenLoading = false;
                    this.loading = false;
                }).catch(err=>{
                    this.fullscreenLoading = false;
                    this.loading = false;
                    this.$notify.error({
                            title: '抓取失败',
                            message: '未知错误，请重试',
                        });
                    console.error(err);
                })
        },
        upLoadDate(){
            // console.log('upload...');
            const url = uploadMatches;
            let successCount = 0;
            let failtCount = 0;
            const requests = [];
            for (let index = 0; index < this.tableData.length; index++) {
                const elm = this.tableData[index];
                // console.log(elm);
                if (elm.hxg !== 0 && elm.axg !== 0) {
                    const request = fetch(url,{
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(elm)
                    })
                    .then(response => response.json())
                    .then(data => {
                        console.log(data.code);
                        if (data.code === 200) {
                            successCount ++;
                        }else{
                            failtCount ++;
                        }
                    })
                    .catch(err=>{
                        console.log(err);
                        failtCount ++;
                    })
                    requests.push(request);
                }
            }
            Promise.all(requests).then(() => {
                console.log('ccccccc',successCount,failtCount);
                this.$notify({
                    title: '上传完成',
                    message: `共${successCount}成功,共${failtCount}失败。`,
                    type: 'success',    
                    // duration: 0
                });
            }).catch(error => {
                console.error('Error:', error);
            });
            
        },
        getzs(){
            const today = this.dateFormatted(new Date());
            const url = '/football/match/zs/' + today;
            fetch(url)
            .then(response => response.json())
            .then(data => {
                console.log('909090',data.data);
            }).catch(err=>{
                console.log('读取数据出错',err);
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '../../assets/sass/global.scss';
</style>